import App from '#components/App'
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch'
import { AuthProvider } from 'oidc-react'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { I18nextProvider } from 'react-i18next'
import { Provider } from 'react-redux'
import { store } from './ag-redux/store'
import './assets/style.scss'
import i18n from './config/i18n'

// these lines are necessary for webpack to include the favicons
// in the dist folder
require('./assets/images/favicon-16x16.gif')
require('./assets/images/favicon-32x32.png')

const container = document.getElementById('azubiguide')
const root = createRoot(container)

root.render(
  <I18nextProvider i18n={i18n}>
    <Provider store={store}>
      <AuthProvider {...OIDC} automaticSilentRenew={true}>
        <App />
      </AuthProvider>
    </Provider>
  </I18nextProvider>,
)
